exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**  rel=\"stylesheet/scss\" lang=\"scss\"*/\n/** backgroud */\n/** border */\n/** table */\n/* Popover\n-------------------------- */\n/* Dialog\n-------------------------- */\n.el-form-item.is-error .wk-signature-pad {\n  border-color: #f56c6c;\n}\n", ""]);

// exports
exports.locals = {
	"xrColorPrimary": "#2362FB"
};